import * as ko from 'knockout';
import { Moment } from "moment";

// Models
import { IFeeModel } from "Content/ts/Models/Join/Interfaces/IFeeModel";
import { IPriceBreakdownDetailsModel } from 'Content/ts//Models/Shared/PriceBreakdown/IPriceBreakdownDetailsModel';
import { BillingMethodEnum } from "Content/ts/Models/Shared/Enums/BillingMethod";
import { PriceDisplayModel } from 'Content/ts/Models/Shared/Pricing/pricingModels';

export class PriceBreakdownDetailsModel {
    CycleFee: KnockoutObservable<PriceDisplayModel>;
    FirstBillDate: KnockoutObservable<Moment>;
    PriceRequestGroupId: KnockoutObservable<number>;
    BillingMethodId: KnockoutObservable<number>;
    BillingCycleId: KnockoutObservable<number>;
    MCD: KnockoutObservable<number>;
    AutomaticDiscount: KnockoutObservable<number>;
    Fees: KnockoutObservableArray<IFeeModel>;
    
    IsDirectDebit: KnockoutComputed<boolean>;
    HasFees: KnockoutComputed<boolean>;
    TotalPrice: KnockoutComputed<number>;

    constructor(model: IPriceBreakdownDetailsModel) {
        this.CycleFee = ko.observable(model.CycleFee);
        this.BillingMethodId = ko.observable(model.BillingMethodId);
        this.BillingCycleId = ko.observable(model.BillingCycleId);
        this.PriceRequestGroupId = ko.observable(model.PriceRequestGroupId);
        this.FirstBillDate = ko.observable(model.FirstBillDate);
        this.MCD = ko.observable(model.MCD);
        this.AutomaticDiscount = ko.observable(model.AutomaticDiscount);
        this.Fees = ko.observableArray(model.Fees);
        
        this.IsDirectDebit = ko.computed(() => {
            return this.BillingMethodId() === BillingMethodEnum.DirectDebit;
        });

        this.HasFees = ko.computed(() => {
            return this.Fees().length > 0;
        });

        this.TotalPrice = ko.computed(() => {
            if (this.HasFees()) {
                const prices = this.Fees().map(f => f.DisplayPrice);
                const isGross = prices[0].IsGross;

                return isGross
                    ? prices.map(p => p.GrossAmount).reduce((a, b) => { return a + b })
                    : prices.map(p => p.NetAmount).reduce((a, b) => { return a + b });
            }

            return 0;
        });
    }
}